import { Injectable, signal } from '@angular/core';
import { AgentSession } from '../interfaces/agent-session';

@Injectable({ providedIn: 'root' })
export class AgentSessionStore {
  readonly sessions = signal<ReadonlyMap<string, AgentSession>>(new Map());

  ensure(scopeId: string): AgentSession {
    const existing = this.sessions().get(scopeId);
    if (existing) return existing;
    const session: AgentSession = { id: crypto.randomUUID(), messages: [], draft: '', attachments: [], diagnostics: [], activities: [], choices: [], status: 'idle' };
    this.sessions.update(sessions => new Map(sessions).set(scopeId, session));
    return session;
  }

  update(scopeId: string, update: (session: AgentSession) => AgentSession): void {
    const previous = this.ensure(scopeId);
    this.sessions.update(sessions => new Map(sessions).set(scopeId, update(previous)));
  }

  clear(): void { this.sessions.set(new Map()); }
}
